module.exports = __webpack_public_path__ + "img/PremierPartner2022.faeb93a7.png";